import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Paper, Avatar } from 'xgimi-ui/mui/material';
import Icon from 'xgimi-ui/Icon';
import Upload from '@/components/Upload';
import StoreComponent, { mapStateToProps } from '@/appComponents/Store';
import image from '@/assets/images';
import s from './.module.scss';

interface Props {
  historyList: Record<string, any>[];
  isDetail :boolean;
  title: string;
}

interface States {
  historyList: Record<string, any>[];
}

/**
 * 历史反馈
 */
class Component extends StoreComponent<Props, States> {
  state: States = {
    historyList: this.props.historyList,
  };
  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback' });
  }
  render(): React.ReactNode {
    return (
      <div className={s.container}>
        {this.state.historyList.map((item: Record<string, any>, index: number) => (
          <div key={index} className={this.props.isDetail ? '' : s.paper_bottom}>
            {/* 问题 */}
            <Paper elevation={0} classes={{ root: s.q }}>
              <div className={s.user}>
                <Avatar className={s.userLogo}>
                  <Icon classes={{ root: s.icon }} type={'assignment'}/>
                </Avatar>
                <span className={s.type}>{item.typeDesc}</span>
              </div>
              <div className={s.content}>
                {item.content}
                <Upload
                  defaultValue={item.imageList?.map((item: Record<string, any>) => item.url)}
                  isUpdate={false}
                  type={['Image', 'Video']}
                />
                <div className={s.time}>
                  <div>{`${moment(item.createdAt).format('YYYY-MM-DD HH:mm')}`}</div>
                </div>
              </div>
            </Paper>
            {/* 回复 */}
            <Paper elevation={0} classes={{ root: this.props.isDetail ? s.paper_top : '' }}>
              <div className={this.props.isDetail ? s.a_detail : s.a}>
                {item.replyList.length > 0 && <Avatar alt="极米科技" src={image.service} variant="square" />}
                <div className={s.reply}>
                  { this.props.isDetail && <div className={s.id}>极米科技</div>}
                  { item.replyList?.map((j: Record<string, any>, sort: number) => (
                    <div key={sort} className={s.replayArea}>
                      <div className={s.content}>{j?.content}</div>
                      <Upload
                        defaultValue={j?.imageList?.map((item: Record<string, any>) => item.url)}
                        isUpdate={false}
                        type={['Image', 'Video']}
                      />
                      {this.props.isDetail && <div className={s.time}>{`${moment(j?.date).format('MM月DD日 HH:mm')}`}</div>}
                    </div>
                  ))}
                </div>
              </div>
            </Paper>
          </div>
        ))}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Component);
